import { RouteRecordRaw } from 'vue-router'
import marketingModules from './marketing-module'

const unifiedPage = () => import('@/modules/Mfa/UnifiedPage.vue')

export const commerceRoutes: RouteRecordRaw[] = [
  {
    path: 'transactional_campaigns/:campaignId/edit',
    name: 'transactional-campaigns',
    meta: {
      module: marketingModules.marketingLegacy.defaultLayoutPage,
    },
    component: unifiedPage,
  },
  {
    path: 'contacts/:contactId/orders',
    alias: ['lists/:listId/contacts/:contactId/orders'],
    name: 'contact-orders',
    meta: {
      module: marketingModules.marketingLegacy.defaultLayoutPage,
    },
    component: unifiedPage,
  },
  {
    path: 'notifications',
    name: 'notifications',
    meta: {
      module: marketingModules.marketing.defaultLayoutPage,
    },
    component: unifiedPage,
  },
]
